module.exports = __webpack_public_path__ + "img/flat-bed-scanner-Right-sitting-dark.679768fb.svg";